import path from 'path'

export function getFileExtension(name) {
    return path.extname(name).toLowerCase()
}
